// extracted by mini-css-extract-plugin
module.exports = {"container":"Order_container__1VMEt","select":"Order_select__Jck3O","option":"Order_option__20jNB"};